var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"mt-2",attrs:{"color":"darkslategray"}},[_vm._v("\n  "+_vm._s(_vm.icon)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }